var map = {
	"./br.json": [
		39126,
		9126
	],
	"./cn.json": [
		28853,
		8853
	],
	"./de.json": [
		79414,
		9414
	],
	"./en.json": [
		50458,
		458
	],
	"./es.json": [
		1298,
		1298
	],
	"./fr.json": [
		69156,
		9156
	],
	"./hk.json": [
		34400,
		4400
	],
	"./it.json": [
		71001,
		1001
	],
	"./jp.json": [
		41481,
		1481
	],
	"./nl.json": [
		97741,
		7741
	],
	"./om.json": [
		18100,
		8100
	],
	"./pt.json": [
		73832,
		3832
	],
	"./ru.json": [
		93626,
		3626
	],
	"./tk.json": [
		15752,
		5752
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 10471;
module.exports = webpackAsyncContext;